import {
  Config as EventListenerConfig,
  useEventListener,
} from './EventListener'

interface Config extends EventListenerConfig {
  onResize: EventListenerConfig['handler']
}

export const useResize = ({ onResize, scope = window }: Config) =>
  useEventListener({ event: 'resize', handler: onResize, scope })
